import useLocalStorage from "@dashboard/hooks/useLocalStorage";
import { type DefaultTheme, ThemeProvider as MacawThemeProvider } from "@saleor/macaw-ui-next";
import { type ReactNode, useEffect } from "react";

import { defaultTheme, localStorageKey } from "./consts";

const primaryButtonColors = {
  default: "#10B981",
  focused: "#10B981",
  hovered: "#059669",
  pressed: "#059669",
};

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [activeTheme] = useLocalStorage<DefaultTheme>(localStorageKey, defaultTheme);

  useEffect(() => {
    const root = document.documentElement;

    root.style.setProperty(
      "--mu-colors-background-button-default-primary",
      primaryButtonColors.default,
    );
    root.style.setProperty(
      "--mu-colors-background-button-default-primary-focused",
      primaryButtonColors.focused,
    );
    root.style.setProperty(
      "--mu-colors-background-button-default-primary-hovered",
      primaryButtonColors.hovered,
    );
    root.style.setProperty(
      "--mu-colors-background-button-default-primary-pressed",
      primaryButtonColors.pressed,
    );
  }, [activeTheme]);

  return <MacawThemeProvider defaultTheme={activeTheme}>{children}</MacawThemeProvider>;
};
